export class ResumeImportErrorWithRedirection extends Error {}
export class ResumeImportEmptyResumeError extends ResumeImportErrorWithRedirection {}
